import React from 'react';
import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import FormItem from '../formItem';

const ProjectForm = ({
	formProps: {
		control,
		formState: { errors },
	},
}) => {
	return (
		<div>
			<FormItem key={'form_name'} label="Name" error={errors?.name?.message}>
				<Controller
					key={'control_name'}
					name="name"
					control={control}
					render={({ field }) => <Input placeholder="Enter your project name" {...field} />}
				/>
			</FormItem>

			<FormItem key={'form_desc'} label="Description" error={errors?.description?.message}>
				<Controller
					key={'control_desc'}
					name="description"
					control={control}
					render={({ field }) => (
						<Input.TextArea rows={4} placeholder="Enter your project description" {...field} />
					)}
				/>
			</FormItem>
		</div>
	);
};

export default ProjectForm;
